import { useLocation, useNavigate, useParams } from "react-router-dom"
import classes from './SearchBoxItem.module.css'
import { useSelector } from "react-redux"
import { frontendOptions } from "../../lib/systemData"
import { formatPatientName } from "../../lib/patientName"
import { workQueuePatientHref } from "../../lib/workQueueNavigation"
import BodySimpleModalV3 from "../../components/common/modal/BodySimpleModalV3"
import PatientOrChart from "../../components/patient/page/PatientOrChart"

const SearchBoxItem = ({ data, searchedText, hideResults}) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { workqSlug } = useParams()

    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);
    const goToPageHandler = () => {
        navigate(workQueuePatientHref(data.person_number, {
            pathname: location.pathname,
            workqSlug,
            selectedWorkQueue,
        }))

        if (hideResults) {
            hideResults()
        }
    }
    
    const MASTER_STATUS = data ? frontendOptions()?.MASTER_STATUS?.find(item => item.value == data.master_status_id) : null
    
    let wholeName = formatPatientName(data)
    let name = wholeName
    
    let index = searchedText ? wholeName.toLowerCase().indexOf(String(searchedText).toLowerCase()) : -1;
    if (index >= 0) { 
        let nameWithHighlight = `${wholeName.substring(0, index)}<span>${wholeName.substring( index , index + searchedText.length)}</span>${wholeName.substring(index + searchedText.length)}`
        name = nameWithHighlight
    } else {
        name = wholeName
    }

    return <li className={classes.list_item}>
        <button onClick={goToPageHandler} className={`${classes.list_item_button}`}>
            <div className="flex-container">
                <PatientOrChart item={{case: data}}/>
                <div className={classes.list_item_detail}>
                    <div className={classes.list_item_name} dangerouslySetInnerHTML={{__html: name}} />
                    <div className={classes.list_item_case}>NG# {data.person_number}</div>
                </div>
            </div>
            {MASTER_STATUS && <BodySimpleModalV3 message={MASTER_STATUS.label} widthAuto={true}>
                <div className={`${classes.list_item_mark} ${classes[MASTER_STATUS.color]}`}></div>    
            </BodySimpleModalV3>}
        </button>
    </li>
}

export default SearchBoxItem